import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useApp } from '../context/AppContext';

//import tags
import { toast, Bounce } from 'react-toastify';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';

//import resources
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { IoIosPricetags } from "react-icons/io";
import { RiShoppingCartLine } from "react-icons/ri";
import { FaRegFilePdf } from "react-icons/fa6";

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

// //import api
import FetchData from '../api/Api';

export default function ProductDetail() {


    //get locale
    const { locale, slug } = useParams();
    const { t } = useTranslation();

    //get data
    const [data, setData] = useState(null);
    const [image, setImage] = useState({
        isActive: 'image',
        src: null
    });
    const {toCart, setToCart} = useApp();
    const [cartAmount, setCartAmount] = useState(1);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale);
                    const result = await fetchDataInstance.get(`/api/product/${slug}`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            setTimeout(function() {
                fetchData();
            }, 200)
            
            
        }

    }, [data, locale, slug]);


    useEffect(()=> {
        setData(null);
    }, [locale])

    const setImageSource = (e) => {
        const { src, id } = e.target;
        setImage((prevImage) => ({
            ...prevImage,
            src: src,
            isActive: id
        }));
    }

    const addToCart = (id) => {
        setToCart((prevCart) => {

            const updatedProducts = prevCart.products || {};
            updatedProducts[id] = cartAmount;
            
            return {
                ...prevCart,
                products: updatedProducts,
            };
        });

        toast.success(t('added_to_cart'), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    const changeCartAmount = (symbol) => {
        setCartAmount((prevAmount) => parseInt(prevAmount) + (symbol === '+' && prevAmount < data?.data?.live_stock ? 1 : (symbol === '-' && prevAmount > 1 ? -1 : 0)));
    };

    useEffect(() => {
        setCartAmount(toCart?.products?.[data?.data?.id] ? toCart?.products?.[data?.data?.id] : 1);
    }, [data])


    return (
        <>
            <Breadcrumb title={t('product')} url='/products/' subtitle={data?.data?.translations?.[0]?.name} />
            <div className='container mx-auto mt-3 lg:mt-12 px-3'>
                <div className="mx-auto my-4 lg:my-10 p-0 lg:p-6 bg-white lg:grid lg:grid-cols-12 lg:gap-10">
                    <div className='col-span-12 lg:col-span-5'>
                        
                        {
                            data === null ? (
                                <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width="100%" height={400} />
                            ) : (
                                data?.data?.img ? (
                                    <img 
                                        className="w-full h-[300px] lg:h-[400px] object-cover rounded-md mb-6"
                                        src={image.src === null ? `${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img}` : image.src} 
                                        alt={data?.data?.translations?.[0]?.name}
                                    />
                                ) : (
                                    ''
                                )
                            )
                        }

                        <div className='flex gap-2 w-full'>
                            {
                                data === null ? (
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} height={100} />
                                ) : (
                                    data?.data?.img ? (
                                        <img 
                                            className={`w-[20%] object-cover h-[100px] rounded-md cursor-pointer ${image.isActive === 'image' ? 'border-2 border-[var(--orange)]' : ''}`}
                                            onClick={(e)=>setImageSource(e)}
                                            id="image"
                                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img}`} 
                                            alt={data?.data?.translations?.[0]?.name}
                                        />
                                    ) : ''
                                )
                            }

                            {
                                data === null ? (
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} height={100} />
                                ) : (
                                    data?.data?.img2 ? (
                                        <img 
                                            className={`w-[20%] object-cover h-[100px] rounded-md cursor-pointer ${image.isActive === 'image2' ? 'border-2 border-[var(--orange)]' : ''}`}
                                            onClick={(e)=>setImageSource(e)}
                                            id="image2"
                                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img2}`} 
                                            alt={data?.data?.translations?.[0]?.name}
                                        />
                                    ) : ''
                                )
                            }

                            {
                                data === null ? (
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} height={100} />
                                ) : (
                                    data?.data?.img3 ? (
                                        <img 
                                            className={`w-[20%] object-cover h-[100px] rounded-md cursor-pointer ${image.isActive === 'image3' ? 'border-2 border-[var(--orange)]' : ''}`}
                                            onClick={(e)=>setImageSource(e)}
                                            id="image3"
                                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img3}`} 
                                            alt={data?.data?.translations?.[0]?.name}
                                        />
                                    ) : ''
                                )
                            }

                            {
                                data === null ? (
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} height={100} />
                                ) : (
                                    data?.data?.img4 ? (
                                        <img 
                                            className={`w-[20%] object-cover h-[100px] rounded-md cursor-pointer ${image.isActive === 'image4' ? 'border-2 border-[var(--orange)]' : ''}`}
                                            onClick={(e)=>setImageSource(e)}
                                            id="image4"
                                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img4}`} 
                                            alt={data?.data?.translations?.[0]?.name}
                                        />
                                    ) : ''
                                )
                            }
                            
                            {
                                data === null ? (
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} height={100} />
                                ) : (
                                    data?.data?.img5 ? (
                                        <img 
                                            className={`w-[20%] object-cover h-[100px] rounded-md cursor-pointer ${image.isActive === 'image5' ? 'border-2 border-[var(--orange)]' : ''}`}
                                            onClick={(e)=>setImageSource(e)}
                                            id="image5"
                                            src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.img5}`} 
                                            alt={data?.data?.translations?.[0]?.name}
                                        />
                                    ) : ''
                                )
                            }

                            
                        </div>
                    </div>
                    
                    <div className='col-span-12 lg:col-span-7'>

                        <h1 className="text-md mt-5 lg:mt-0 lg:text-2xl font-bold text-gray-800 mb-4">
                          
                            {
                                data === null ?
                                <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} />
                                :
                                (data?.data?.translations?.[0]?.name ? (
                                    (data.data.translations[0].name)
                                ) : (
                                    'No title'
                                ))
                            }
                        </h1>

                        <p className="text-3xl mb-6 flex items-center text-[var(--orange)]">
                            <IoIosPricetags className='me-2' />
                            
                            {
                                data === null ?
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} width={200} />
                                :
                                (data?.data?.discounted ?
                                    <>
                                        <span className="">{ data.data.discounted } ₾</span>
                                        <span className="text-gray-400 text-xl line-through ms-3">{ data.data.price } ₾</span>
                                    </>
                                :
                                (data?.data?.price ? (
                                    `${data.data.price} ₾`
                                ) : (
                                    'No Price'
                                )))
                            }
                        </p>
                        <div className='mb-2'>
                            <div>
                                <div className='text-gray-400 mb-3'>{t('available')}:</div>
                                {
                                    data?.data?.stocks?.map((stock, index)=> {
                                        return (
                                            <div key={index} className={`px-2 py-1 ${index === 0 ? '' : 'ms-2'} rounded-3xl cursor-pointer text-[13px] inline-flex items-center gap-2 bg-gray-100`}>
                                                <img className='h-[40px] w-[40px] object-contain bg-white rounded-full object-center' src={`${process.env.REACT_APP_API_URL}/storage/uploads/warehouse/${stock.warehouse.img}`} alt={stock.warehouse.translations[0].name} />
                                                {stock.warehouse.translations[0].name}
                                            </div>
                                        )
                                    })
                                }
                                
                                
                            </div>
                            
                        </div>
                        <div className='border-y border-gray-200 pt-2 pb-2 mt-4 mb-4'>
                            <div className='flex items-center'>
                                <div className='text-gray-400'>{t('instruction')}:</div>
                                {
                                    data?.data?.pdf ? 
                                        <Link to={`${process.env.REACT_APP_API_URL}/storage/uploads/products/${data.data.pdf}`} target='_blank' className='px-2 py-1 ms-2 rounded-3xl cursor-pointer text-sm flex items-center gap-2'>
                                            <FaRegFilePdf />
                                            {t('instruction')}
                                        </Link>
                                    :
                                    <span className='px-2 py-1 ms-2 rounded-3xl cursor-pointer text-sm flex items-center gap-2'>--</span>
                                }
                            </div>
                        </div>
                        
                        {
                            data?.data?.live_stock ? 
                                <div className='mb-2 mt-5'>
                                    <div className='flex items-center'>
                                        <div className='cursor-pointer text-md flex items-center gap-2'>
                                            <div className='flex bg-gray-200 h-[45px] items-center justify-between rounded-3xl'>
                                                <div className='w-[45px] h-[45px] flex items-center justify-center' onClick={()=>changeCartAmount('-')}>-</div>
                                                <div className='w-[45px] h-[45px] flex items-center justify-center'>{cartAmount}</div>
                                                <div className='w-[45px] h-[45px] flex items-center justify-center' onClick={()=>changeCartAmount('+')}>+</div>
                                                <div
                                                    onClick={() => addToCart(data?.data?.id)}
                                                    className={`cursor-pointer bg-[var(--orange)] w-[45px] h-[45px] flex items-center justify-center border-4 border-white rounded-full z-20 text-[20px]`}
                                                >
                                                    <RiShoppingCartLine />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            :

                            <div className="text-[15px] font-bold text-red-600">{t('out_of_stock')}</div>
                        }
                        

                        <div className="text-gray-700 leading-relaxed mt-10">
                            <div className="mb-4 text-[13px] lg:text-[15px]">
                                {
                                    data === null ?
                                        <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={20} count={5} />
                                    :
                                    (data?.data?.translations?.[0]?.details ? (
                                        (<p dangerouslySetInnerHTML={{ __html: data.data.translations[0].details }} />)
                                    ) : (
                                        'No Details'
                                    ))
                                }
                                
                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>
        </>
    );
}